export const CLOSED_STATUS_NAME = 'Zatvoren'
